import React from 'react';

import { Link } from 'react-router-dom';

import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone';
import { IconButton } from '@mui/material';

type Props = {
  offer: {
    result: App.Offer & {
      videos: {
        luxuryescapes: {
          vimeo_id: string;
        };
        scoopontravel: {
          vimeo_id: string;
        };
      };
    };
  };
};

export default function VideoPane({ offer }: Props) {
  const { id_salesforce_external, videos } = offer.result;
  return (
    <span>
      <h1>
        <Link to={`/edit-offers/${id_salesforce_external}/videos`}>
          <IconButton aria-label="Edit">
            <ModeEditTwoToneIcon fontSize="large" />
          </IconButton>
        </Link>
      </h1>
      <h2>Luxury Escapes</h2>
      {videos.luxuryescapes.vimeo_id && videos.luxuryescapes.vimeo_id != 'undefined' && (
        <div className="embed-responsive embed-responsive-16by9" style={{ marginTop: '10px' }}>
          <iframe
            width="560"
            height="315"
            src={`https://player.vimeo.com/video/${videos.luxuryescapes.vimeo_id}`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      )}
      <h2>Scoopon</h2>
      {videos.scoopontravel.vimeo_id && videos.scoopontravel.vimeo_id != 'undefined' && (
        <div className="embed-responsive embed-responsive-16by9" style={{ marginTop: '10px' }}>
          <iframe
            width="560"
            height="315"
            src={`https://player.vimeo.com/video/${videos.scoopontravel.vimeo_id}`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      )}
    </span>
  );
}
